<ejs-grid #grid
          class="grid-with-toolbar"
          width="100%"
          rowHeight="38"
          [dataSource]="configurationFormGeneral.get('userAccessList').value"
          [allowSorting]="false"
          [allowFiltering]="false"
          [allowPaging]="false"
          [editSettings]="customEditSettings"
          (checkBoxChange)="checkBoxChange($event)"
          (rowDeselecting)="handleRowSelectingOrDeselecting($event)"
          (rowDeselected)="rowsDeselected($event)"
          (rowSelecting)="handleRowSelectingOrDeselecting($event)"
          (rowSelected)="rowsSelected($event)"
          (actionComplete)="actionComplete($event)"
          (actionBegin)="actionBegin($event)">
  <e-columns>
    <e-column headerText='id' field='userId' [visible]='false' [isPrimaryKey]='true'></e-column>
    <e-column type="checkbox"
              field="hasAccess"
              headerText="{{'i18n.domain.export-configuration.configurations.forms.general.grid.access' | translate}}"
              width="80"
              textAlign="Center">
    </e-column>
    <e-column field="userName"
              headerText="{{'i18n.domain.export-configuration.configurations.forms.general.grid.user-name' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column field="email"
              headerText="{{'i18n.shared.fields.email' | translate}}"
              clipMode="EllipsisWithTooltip"
              [visible]="showEmail">
    </e-column>
    @if (isUserAdminOrClientAdmin) {
      <e-column headerText=""
                [commands]="gridCommands"
                width="60px">
      </e-column>
    }
  </e-columns>
  <ng-template #editSettingsTemplate let-data>
    <app-user-edit-form [userEditForm]="gridEditForm"></app-user-edit-form>
  </ng-template>
</ejs-grid>
